import type { LucideIcon } from 'lucide-react'

export type CardTab<T extends string> = {
  key: T
  label: string
  icon: LucideIcon
  badge?: number | string
  badgeTone?: 'ok' | 'warn' | 'fail'
}

// Card-style tab bar (icon + label + optional count badge); the active item
// gets the accent underline from .tabs button.active::after.
export function CardTabs<T extends string>({ tabs, active, onChange }: {
  tabs: readonly CardTab<T>[]
  active: T
  onChange: (key: T) => void
}) {
  return (
    <div className="tabs" role="tablist">
      {tabs.map(({ key, label, icon: Icon, badge, badgeTone }) => (
        <button
          key={key}
          role="tab"
          aria-selected={key === active}
          className={key === active ? 'active' : ''}
          onClick={() => onChange(key)}
        >
          <Icon size={16} />
          {label}
          {badge != null && badge !== 0 && (
            <span className={`tab-badge${badgeTone ? ` ${badgeTone}` : ''}`}>{badge}</span>
          )}
        </button>
      ))}
    </div>
  )
}
